import quickFetch from 'quick-fetch';

interface QuickFetchOptions<T> {
  makeRequestFn: () => Promise<T>;
  requestName: string;
}

export function makeQuickFetchRequest<T>(options: QuickFetchOptions<T>) {
  const { makeRequestFn, requestName } = options;

  const earlyRequest = quickFetch.getRequestStateByName(requestName);

  if (!earlyRequest) {
    return { requestPromise: makeRequestFn(), usedQuickfetch: false };
  }

  const requestPromise: Promise<T> = new Promise((resolve, reject) => {
    earlyRequest.whenFinished((result: T) => {
      resolve(result);
      quickFetch.removeEarlyRequest(requestName);
    });
    earlyRequest.onError(() => {
      makeRequestFn()
        .then(resolve, reject)
        .catch((error) => {
          console.error(error);
        });
      quickFetch.removeEarlyRequest(requestName);
    });
  });

  return { requestPromise, usedQuickfetch: true };
}
